import { render, staticRenderFns } from "./MultipleDialogCallback.vue?vue&type=template&id=6d6a56f0&lang=pug&"
import script from "./MultipleDialogCallback.vue?vue&type=script&lang=ts&"
export * from "./MultipleDialogCallback.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports